export default {
  getUnidadesNegocio(state) {
    return state.unidadesNegocio;
  },
  getUnidadesNegocioComObj(state) {
    return state.unidadesNegocioComObj;
  },
  getUnidadesSelecionadas(state) {
    return state.unidadesNegocioSelecionada;
  },
};
